import React from 'react';
import { Calendar } from 'lucide-react';
import { cn } from '../../utils';

interface DatePickerProps {
  label?: string;
  error?: string;
  helperText?: string;
  value: string;
  onChange: (value: string) => void;
  minDate?: string;
  maxDate?: string;
  isLoading?: boolean;
  className?: string;
  id?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  error,
  helperText,
  value,
  onChange,
  minDate,
  maxDate,
  isLoading,
  className,
  id,
}) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  // Set default min date to today
  const today = new Date().toISOString().split('T')[0];
  const defaultMinDate = minDate || today;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
        </label>
      )}
      
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Calendar className="w-4 h-4 text-gray-400" />
        </div>
        
        <input
          id={inputId}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          min={defaultMinDate}
          max={maxDate}
          disabled={isLoading}
          className={cn(
            'block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm',
            error && 'border-red-300 focus:ring-red-500 focus:border-red-500',
            isLoading && 'opacity-50 cursor-not-allowed',
            className
          )}
        />
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
      
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default DatePicker;